import React, { useState, useEffect } from "react";
import { SelectButton } from 'primereact/selectbutton';
import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApi from 'hooks/useApi';
import useApp from 'hooks/useApp';
import useAuth from 'hooks/useAuth';
import useUtils from 'hooks/useUtils';
import { Uploader } from 'components/Uploader';
import { useNavigate } from "react-router-dom";
import useAddPage from 'hooks/useAddPage';
const AddMandate = (props) => {
		const auth = useAuth();
	const app = useApp();
	const api = useApi();
	const utils = useUtils();
	
	//form validation rules
	const validationSchema = yup.object().shape({
		loanaccountno: yup.string().required().label("Loan Account No"),
		customername: yup.string().required().label("Customer Name"),
		customermobile: yup.string().required().label("Mobile"),
		customeremail: yup.string().email().nullable().label("Mail"),
		mdate: yup.string().nullable().label("Mdate"),
		accountholdername: yup.string().required().label("Account Name"),
		accountnumber: yup.string().required().label("Account Number"),
		bankifsc: yup.string().required().label("IFSC"),
		accounttype: yup.string().nullable().label("Account Type"),
		amounttype: yup.string().nullable().label("Amounttype"),
		authtype: yup.string().nullable().label("Authtype"),
		bankcode: yup.string().nullable().label("Bankcode"),
		loanproductid: yup.string().nullable().label("Loan Product"),
		interestrate: yup.number().required().label("Interestrate"),
		processingfee: yup.number().nullable().label("Processingfee"),
		loanterm: yup.number().nullable().label("Loanterm"),
		principalamount: yup.number().required().label("Principalamount"),
		frequency: yup.string().required().label("Frequency"),
		collectionamount: yup.number().required().label("Collectionamount"),
		firstcollectiondate: yup.string().required().label("Firstcollectiondate"),
		lastcollectiondate: yup.string().nullable().label("Lastcollectiondate"),
		userid: yup.number().nullable().label("Userid"),
        photo: yup.string().nullable().label("Photo")
	});
	
	//form default values
	const formDefaultValues = {
		loanaccountno: '', 
		customername: '', 
		customermobile: '', 
		customeremail: '', 
		mdate: new Date(), 
		accountholdername: '', 
		accountnumber: '', 
		bankifsc: '', 
		accounttype: '', 
		amounttype: "M", 
		authtype: 'all', 
		bankcode: '', 
		loanproductid: '', 
		interestrate: '', 
		processingfee: '', 
		loanterm: '', 
		principalamount: '', 
		frequency: '', 
		collectionamount: '', 
		firstcollectiondate: new Date(), 
		lastcollectiondate: new Date(), 
		userid: auth.userId, 
        photo: '', 
	}
	
	const pageController = useAddPage({ props, formDefaultValues, afterSubmit });
	const {
		formData,
		resetForm,
		submitForm,
		pageReady,
		loading,
		saving,
		inputClassName,
	} = pageController;

	const [step, setStep] = useState(1);
	const stepTitles = ["Customer Info", "Loan Details", "Mandate Details"];

//kyc check


const navigate = useNavigate();
  const [kyc, setKyc] = useState(null);

useEffect(() => {
  const loadKycStatus = async () => {
    try {
        const userId = auth.userId;   // <--- GET USER ID FROM AUTH
      const apiBase = process.env.REACT_APP_API_PATH;
      if (!apiBase) {
        console.error("❌ ENV not loaded! API cannot fire.");
        return;
      }
      const url = `${apiBase.replace(/\/$/, '')}/kyc/kyc-status?userId=${userId}`;
      console.log("Calling URL =", url);
      const response = await fetch(url);
      console.log("Response object:", response);
      if (!response.ok) {
        console.error("❌ API Error:", response.status);
        return;
      }
      const data = await response.json();
      console.log("KYC Data:", data);
      setKyc(data);
      if (!data.isKycCompleted) {
        navigate("/kyc", { replace: true });
      }
    } catch (err) {
      console.error("KYC API failed:", err);
    }
  };
  loadKycStatus();
}, [navigate]);




	function afterSubmit(response) {
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		resetForm();
		if (app.isDialogOpen()) {
			app.closeDialogs();
		} else if (props.redirect) {
			app.navigate(`mandateworld/view/${response.loanaccountno}`);
		}
	}

	
	//auto fill other inputs on customername change
	async function customernameAutoFill(e, formik, index) {
		formik.handleChange(e);
var number = auth.userId;
var formatted = number.toString().padStart(4, '0');
var lno= 'L'+utils.randomNum(6)+formatted;
formik.setFieldValue('loanaccountno',lno);
	};
	
	//auto fill other inputs on loanproductid change
	async function loanproductidAutoFill(e, formik, index) {
		formik.handleChange(e);
		const val = e.target.value;
		const resp = await api.get(`components_data/mandateworld_loanproductid_autofill?value=${val}`);
		const data = resp.data[0];
		if(data){
formik.setFieldValue('frequency', data.frequency);
formik.setFieldValue('interestrate', data.interestrate);
formik.setFieldValue('processingfee', data.processingfee);
formik.setFieldValue('loanterm', data.loanterm);
		}
	};

    //auto fill other inputs on principalamount change
	async function principalamountAutoFill(e, formik, index) {
		formik.handleChange(e);
		const val = e.target.value;
		const resp = await api.get(`components_data/mandateworld_principalamount_autofill?value=${val}`);
		const data = resp.data[0];
		if(data){
		}
	};

const toDateInputValue = (date) => {
    if (!date) return "";
    return date.toISOString().split("T")[0];
};

 function calculateCollectionData({ 
    principal, 
    interestrate, 
    loanterm, 
    frequency, 
    firstcollectiondate 
}) {
    principal = Number(principal);
    const annualRate = Number(interestrate);
    const loanTerm = Number(loanterm);

    // ---------------------------
    // 1️⃣ Convert annual interest to term interest
    // ---------------------------
    let termInYears = 0;

    switch (frequency) {
        case "DAIL":
            termInYears = loanTerm / 365;
            break;
        case "WEEK":
            termInYears = loanTerm / 52;
            break;
        case "MNTH":
            termInYears = loanTerm / 12;
            break;
    }

    // Total flat interest
    const totalInterest = principal * (annualRate / 100) * termInYears;

    // Total payable
    const totalPayable = principal + totalInterest;

    // ---------------------------
    // 2️⃣ Collection amount per installment
    // ---------------------------
    const collectionAmount = Number((totalPayable / loanTerm).toFixed(2));

    // ---------------------------
    // 3️⃣ Auto-calc Last Collection Date
    // ---------------------------
    let lastCollectionDate = null;

    

    if (firstcollectiondate) {
        const firstDate = new Date(firstcollectiondate);
        let lastDate = new Date(firstDate);

        if (frequency === "DAIL") {
            lastDate.setDate(firstDate.getDate() + (loanTerm - 1));
        } else if (frequency === "WEEK") {
            lastDate.setDate(firstDate.getDate() + (7 * (loanTerm - 1)));
        } else if (frequency === "MNTH") {
            lastDate.setMonth(firstDate.getMonth() + loanTerm-1);
        }

      lastCollectionDate = lastDate
      //formatDate(lastDate, "YYYY-MM-DD");

      
           // If you want NEXT day after last installment
    
    }

    return {
        collectionAmount,
        lastCollectionDate
    };
}


const formatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

async function firstCollectionDateAutoFill(e, formik) {
    formik.handleChange(e);

    const val = e.value;  
    if (!val) return;

    const formattedDate = formatDate(val, "YYYY-MM-DD");

    // Get needed values from form
    const principal = formik.values.principalamount;
    const interestrate = formik.values.interestrate;
    const loanterm = formik.values.loanterm;
    const frequency = formik.values.frequency;

    // ⭐ Calculate JS version locally
    const calc = calculateCollectionData({
        principal,
        interestrate,
        loanterm,
        frequency,
        firstcollectiondate: formattedDate
    });

    // Update collection amount & last date
    formik.setFieldValue("collectionamount", calc.collectionAmount);

    if (calc.lastCollectionDate)
        formik.setFieldValue("lastcollectiondate", calc.lastCollectionDate);

    // ⬇ Optional — call API also
    try {
        const resp = await api.get(
            `components_data/mandateworld_firstcollectiondate_autofill?value=${formattedDate}`
        );

        const data = resp.data[0];

        if (data?.emidate) {
            formik.setFieldValue("emidate", new Date(data.emidate));
        }
    } catch (err) {
        console.error("Error fetching collection date info", err);
    }
}

  
	
	// page loading form data from api
if (loading) {
  return (
    <div className="p-3 text-center">
      <ProgressSpinner style={{ width: '50px', height: '50px' }} />
    </div>
  );
}

	
    // Validation per step
	const validateStep = async (values, formikErrors, setErrors) => {
		const fieldsByStep = {
			1: ["customername", "customermobile", "customeremail"],
			2: ["accountholdername", "accountnumber", "bankifsc"],
			3: [
				"loanaccountno",
				"loanproductid",
				"firstcollectiondate",
				"principalamount",
				"interestrate",
				"processingfee",
				"loanterm",
				"frequency",
			],
		};
		const stepFields = fieldsByStep[step];
		const stepErrors = {};
		for (const key of stepFields) {
			if (formikErrors[key]) stepErrors[key] = formikErrors[key];
		}
		if (Object.keys(stepErrors).length > 0) {
			setErrors(stepErrors);
			return false;
		}
		return true;
	};

	//page has loaded any required data and ready to render
	if(pageReady){
		return (
<main id="AddMandate" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container-fluid">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label=""  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title="Add New Mandate"   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="col comp-grid" >
                    <div >
                        <Formik initialValues={formData} validationSchema={validationSchema} onSubmit={(values, actions) =>submitForm(values)}>
                            {(formik) => 
                            <>
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>

                                	{/* STEP 1 */}
								{step === 1 && (
                                <div className="grid">
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Loan Account No *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="loanaccountno"  onChange={formik.handleChange}  value={formik.values.loanaccountno}   label="Loan Account No" type="text" placeholder="Enter Loan Account No"     disabled   className={inputClassName(formik?.errors?.loanaccountno)} />
                                                <ErrorMessage name="loanaccountno" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Customer Name *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="customername"  onChange={(e)=>customernameAutoFill(e, formik)}  value={formik.values.customername}   label="Customer Name" type="text" placeholder="Enter Customer Name"        className={inputClassName(formik?.errors?.customername)} />
                                                <ErrorMessage name="customername" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Mobile *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="customermobile"  onChange={formik.handleChange}  value={formik.values.customermobile}   label="Mobile" type="text" placeholder="Enter Mobile"        className={inputClassName(formik?.errors?.customermobile)} />
                                                <ErrorMessage name="customermobile" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Mail 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="customeremail"  onChange={formik.handleChange}  value={formik.values.customeremail}   label="Mail" type="email" placeholder="Enter Mail"        className={inputClassName(formik?.errors?.customeremail)} />
                                                <ErrorMessage name="customeremail" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Mdate 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="mdate" showButtonBar className={inputClassName(formik?.errors?.mdate)} dateFormat="yy-mm-dd" value={formik.values.mdate} onChange={formik.handleChange} showIcon        />
                                                <ErrorMessage name="mdate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                      <div className="md:col-6 col-12">
                                                                            <div className="formgrid grid">
                                                                                <div className="col-12 md:col-3">
                                                                                    Photo 
                                                                                </div>
                                                                                <div className="col-12 md:col-9">
                                                                                    <div className={inputClassName(formik?.errors?.photo)}>
                                                                                        <Uploader name="photo" showUploadedFiles value={formik.values.photo} uploadPath="fileuploader/upload/photo" onChange={(paths) => formik.setFieldValue('photo', paths)} fileLimit={1} maxFileSize={3} accept=".jpg,.png,.gif,.jpeg" multiple={false} label="Choose files or drop files here" onUploadError={(errMsg) => app.flashMsg('Upload error', errMsg, 'error')} />
                                                                                    </div>
                                                                                    <ErrorMessage name="photo" component="span" className="p-error" />
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                    </div>
                                    )}

                                    {/* STEP 2 */}
								{step === 2 && (

                                    <div className="grid">
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Account Name *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="accountholdername"  onChange={formik.handleChange}  value={formik.values.accountholdername}   label="Account Name" type="text" placeholder="Enter Account Name"        className={inputClassName(formik?.errors?.accountholdername)} />
                                                <ErrorMessage name="accountholdername" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Account Number *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="accountnumber"  onChange={formik.handleChange}  value={formik.values.accountnumber}   label="Account Number" type="text" placeholder="Enter Account Number"        className={inputClassName(formik?.errors?.accountnumber)} />
                                                <ErrorMessage name="accountnumber" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                IFSC *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="bankifsc"  onChange={formik.handleChange}  value={formik.values.bankifsc}   label="IFSC" type="text" placeholder="Enter IFSC"        className={inputClassName(formik?.errors?.bankifsc)} />
                                                <ErrorMessage name="bankifsc" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Account Type 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Dropdown  name="accounttype"     optionLabel="label" optionValue="value" value={formik.values.accounttype} onChange={formik.handleChange} options={app.menus.accounttype} label="Account Type"  placeholder="Select a value ..."  className={inputClassName(formik?.errors?.accounttype)}   />
                                                <ErrorMessage name="accounttype" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                   <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Authtype 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="authtype"  onChange={formik.handleChange}  value={formik.values.authtype}   label="Authtype" type="text" placeholder="Enter Authtype"     disabled   className={inputClassName(formik?.errors?.authtype)} />
                                                <datalist id="authtype_list">
                                                { app.menus.authtype.map((option, index)=> <option key={index} value={option.value}>{option.label}</option>)}
                                                </datalist>
                                                <ErrorMessage name="authtype" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                 
                                      <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Bankcode 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/bankcode_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="bankcode"     optionLabel="label" optionValue="value" value={formik.values.bankcode} onChange={formik.handleChange} options={response} label="Bankcode"  placeholder="Select a value ..." filter={true} className={inputClassName(formik?.errors?.bankcode)}   />
                                                    <ErrorMessage name="bankcode" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>

                                    </div>
                                    )}

	                            {/* STEP 3 */}
								{step === 3 && (
									<div className="grid">

                                        <div className="md:col-6 col-12">
                                                                          <div className="formgrid grid">
                                                                              <div className="col-12 md:col-3">
                                                                                  Loan Product 
                                                                              </div>
                                                                              <div className="col-12 md:col-9">
                                                                                  <DataSource   apiPath="components_data/loanproductid_option_list"  >
                                                                                      {
                                                                                      ({ response }) => 
                                                                                      <>
                                                                                      <SelectButton name="loanproductid" className={inputClassName(formik?.errors?.loanproductid, '')} value={formik.values.loanproductid} onChange={(e)=>loanproductidAutoFill(e, formik)} options={response} optionLabel="label" optionValue="value" />
                                                                                      <ErrorMessage name="loanproductid" component="span" className="p-error" />
                                                                                      </>
                                                                                      }
                                                                                  </DataSource>
                                                                              </div>
                                                                          </div>
                                                                      </div>

                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Interestrate *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="interestrate"  onChange={formik.handleChange}  value={formik.values.interestrate}   label="Interestrate" type="number" placeholder="Enter Interestrate"  min={0}  step={0.1} disabled   className={inputClassName(formik?.errors?.interestrate)} />
                                                <ErrorMessage name="interestrate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Processingfee 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="processingfee"  onChange={formik.handleChange}  value={formik.values.processingfee}   label="Processingfee" type="number" placeholder="Enter Processingfee"  min={0}  step={0.1} disabled   className={inputClassName(formik?.errors?.processingfee)} />
                                                <ErrorMessage name="processingfee" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Loanterm 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="loanterm"  onChange={formik.handleChange}  value={formik.values.loanterm}   label="Loanterm" type="number" placeholder="Enter Loanterm"  min={0}  step="any"    className={inputClassName(formik?.errors?.loanterm)} />
                                                <ErrorMessage name="loanterm" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                       <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Principalamount *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="principalamount"  onChange={(e)=>principalamountAutoFill(e, formik)}  value={formik.values.principalamount}   label="Principalamount" type="number" placeholder="Enter Principalamount"  min={0}  step="any"    className={inputClassName(formik?.errors?.principalamount)} />
                                                <ErrorMessage name="principalamount" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Frequency *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="frequency"  onChange={formik.handleChange}  value={formik.values.frequency}   label="Frequency" type="text" placeholder="Enter Frequency"   disabled      className={inputClassName(formik?.errors?.frequency)} />
                                                <ErrorMessage name="frequency" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Collectionamount *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="collectionamount"  onChange={formik.handleChange}  value={formik.values.collectionamount}   label="Collectionamount" type="number" placeholder="Enter Collectionamount"  min={0}  step="any"  disabled   className={inputClassName(formik?.errors?.collectionamount)} />
                                                <ErrorMessage name="collectionamount" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Firstcollectiondate *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="firstcollectiondate" showButtonBar className={inputClassName(formik?.errors?.firstcollectiondate)} dateFormat="yy-mm-dd" value={formik.values.firstcollectiondate}  onChange={(e) => firstCollectionDateAutoFill(e, formik)} showIcon        />
                                                <ErrorMessage name="firstcollectiondate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Lastcollectiondate 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="lastcollectiondate" showButtonBar className={inputClassName(formik?.errors?.lastcollectiondate)} dateFormat="yy-mm-dd" value={formik.values.lastcollectiondate} onChange={formik.handleChange} showIcon        />
                                                <ErrorMessage name="lastcollectiondate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Userid 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="userid"  onChange={formik.handleChange}  value={formik.values.userid}   label="Userid" type="number" placeholder="Enter Userid"  min={0}  step="any" disabled   className={inputClassName(formik?.errors?.userid)} />
                                                <DataSource   apiPath="components_data/userid_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <datalist id="userid_list">
                                                    { response.map((option, index)=> <option key={index} value={option.value}>{option.label}</option>)}
                                                    </datalist>
                                                    </>
                                                    }
                                                </DataSource>
                                                <ErrorMessage name="userid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                    )}

                               
                               

                                  {/* Navigation Buttons */}
                                                            <div className="flex justify-between mt-4">
                                                                {step > 1 && (
                                                                    <Button
                                                                        type="button"
                                                                        label="Back"
                                                                        icon="pi pi-arrow-left"
                                                                        onClick={() => setStep(step - 1)}
                                                                        className="p-button-secondary"
                                                                    />
                                                                )}
                              
                                                                {step < 3 && (
                                                                    <Button
                                                                        type="button"
                                                                        label="Next"
                                                                        icon="pi pi-arrow-right"
                                                                        iconPos="right"
                                                                        className="p-button-primary ml-auto"
                                                                        onClick={async () => {
                                                                            const valid = await validateStep(formik.values, formik.errors, formik.setErrors);
                                                                            if (valid) setStep(step + 1);
                                                                        }}
                                                                    />
                                                                )}
                              
                                                                {step === 3 && (
                                                                    <Button
                                type="submit"
                                label="Submit & Next"
                                icon="pi pi-send"
                                className="p-button-success ml-auto"
                                loading={saving}
                                onClick={formik.handleSubmit}
                              />
                              
                                                                )}
                                                            </div>
                                                            
                            </Form>
                            </>
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}

//page props and default values
AddMandate.defaultProps = {
	primaryKey: 'loanaccountno',
	pageName: 'mandateworld',
	apiPath: 'mandateworld/add',
	routeName: 'mandateworldadd',
	submitButtonLabel: "Submit & Next",
	formValidationError: "Form is invalid",
	formValidationMsg: "Please complete the form",
	msgTitle: "Create Record",
	msgAfterSave: "Record added successfully",
	msgBeforeSave: "",
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default AddMandate;
